// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__35cFF","page":"style_page__2pIJh","input":"style_input__1aSkv","divButton":"style_divButton__3a2cp","error":"style_error__20kJi"};